import React, { useState,useEffect } from 'react';
import TopTitle from './TopTitle';
import {instance} from './common';


function Allim(){

    const session = JSON.parse(window.sessionStorage.result);
    const [data, setData] = useState([]);


    useEffect(() => {
        const common = {
            sigong_seq:session.u_sigong,
            others:0,
            view_check:0
        }

        instance.post(`/common/v2/condition`,{table:'fcm_push',common:common}).then(function (res) {
            setData(res.data)
        });
    },[])

    console.log('data : ', data)

    const box = {
        borderRadius:'10px',
        border:'1px solid #01489D',
        padding:'10px'
    }

    const deletePush = (seq) => {
        const delData = data.filter(v => v.fc_seq !== seq)
        setData(delData)
        instance.post(`/common/update`,{table:'fcm_push',common:{others:1},field:'fc_seq',value:seq}).then(function (res) {
        });
    }

    return (
        <>
        <TopTitle title="알림" />
        <div className='container'>
            {
                data.map((v,i) => <div className="position-relative mb-2" style={box} key={i}>
                    <p className="float-left font-weight-bold mb-0">{v.fc_message}</p>
                    <div style={{clear:'both'}}></div>
                    <p className="float-left mb-0">{v.fc_date}</p>
                    <div style={{clear:'both'}}></div>
                    <span style={{position:'absolute',right:'5px',top:'0px',color:'#DC383B'}} onClick={()=>deletePush(v.fc_seq)}>x</span>
                </div>)
            }
            
        </div>
        </>
    )
}


export default Allim;